import React, { useMemo } from "react";
import ProductCard from "./ProductCard";

/**
 * ProductGrid - Composant de rendu final de la liste des produits.
 * Intègre un filtrage par catégorie et une sécurité sur les données d'audit.
 */
const DEBUG_AUDIT_WARN = false;

export default function ProductGrid({
  produitsAffiches = [],
  categorieActive,
  vueActuelle,
  t,
  ajouterAuPanier,
  storyActive,
  setStoryActive,
  isProfilReady, // lié à isAuthResolved depuis BoutiqueContent
  profilPricing,
  onProductClick, // (optionnel)
}) {
  const safeProducts = useMemo(
    () => (Array.isArray(produitsAffiches) ? produitsAffiches : []),
    [produitsAffiches]
  );

  const filtered = useMemo(() => {
    return safeProducts.filter((p) => {
      if (
        !categorieActive ||
        categorieActive === "Toutes" ||
        vueActuelle === "actions"
      ) {
        return true;
      }
      const catProduit = p?.category || p?.categorie;
      return catProduit === categorieActive;
    });
  }, [safeProducts, categorieActive, vueActuelle]);

  // --- ÉTAT VIDE ---
  if (!filtered.length) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          width: "100%",
          color: "#666",
        }}
      >
        <p>{t?.noProducts || "Aucun produit trouvé."}</p>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {filtered.map((p) => {
        // --- LOGIQUE D'AUDIT (PRIX EN CENTS) ---
        const audit = p?.audit || {
          price: p?.price,
          isDiscount: p?.isDiscount,
        };

        if (DEBUG_AUDIT_WARN && !p?.audit) {
          console.warn(
            `[ProductGrid] Audit manquant pour ID: ${p?.id} - Utilisation du fallback.`
          );
        }

        return (
          <ProductCard
            key={`${vueActuelle}-${p?.id ?? p?.name ?? Math.random()}`}
            product={p}
            audit={audit}
            t={t}
            vueActuelle={vueActuelle}
            storyActive={storyActive}
            setStoryActive={setStoryActive}
            ajouterAuPanier={ajouterAuPanier}
            isProfilReady={isProfilReady}
            profilPricing={profilPricing}
            onProductClick={onProductClick}
          />
        );
      })}
    </div>
  );
}
